import React from 'react';
import { Link } from 'react-router-dom';
import { StethoscopeIcon, BrainIcon, BriefcaseIcon, GraduationCapIcon, ChevronRightIcon } from 'lucide-react';
export function Services() {
  const serviceCategories = [{
    title: 'Medical & Wellness',
    icon: <StethoscopeIcon className="h-8 w-8 text-brand-red" data-id="element-168" />,
    description: 'Comprehensive healthcare focused on prevention and long-term vitality.',
    items: ['Family Practice & Lifestyle Wellness', 'Health Risk Assessments (HRAs)', 'Chronic Disease Management', 'Preventive Care & Wellness Exams', 'Comprehensive Health Evaluations']
  }, {
    title: 'Mental Health & Coaching',
    icon: <BrainIcon className="h-8 w-8 text-brand-red" data-id="element-169" />,
    description: "Restoring emotional strength and rediscovering life's purpose.",
    items: ['Marriage and Family Coaching', 'Trauma and PTSD Recovery Support', 'Anxiety and Depression Support', 'Grief and Loss Support', 'Life Recovery and Purpose Coaching']
  }, {
    title: 'Consultation & Training',
    icon: <BriefcaseIcon className="h-8 w-8 text-brand-red" data-id="element-170" />,
    description: 'Expert guidance for organizations and healthcare professionals.',
    items: ['Professional Consultation', 'Organizational Wellness Programs', 'Mental Health Awareness Training', 'Critical Care Consultation', 'Care Coordination']
  }];
  return <section id="services" className="py-24 bg-brand-light" data-id="element-171">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="text-center mb-16" data-id="element-173">
          <h2 className="text-brand-red font-bold tracking-wider uppercase text-sm mb-4" data-id="element-174">
            Our Services
          </h2>
          <h3 className="text-3xl lg:text-4xl font-bold text-brand-navy" data-id="element-175">
            Comprehensive Care for Body & Mind
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-176">
          {serviceCategories.map((category, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-177">
              <div className="bg-brand-light w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-178">
                {category.icon}
              </div>
              <h4 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-179">
                {category.title}
              </h4>
              <p className="text-gray-600 mb-6" data-id="element-180">{category.description}</p>
              <ul className="space-y-3" data-id="element-181">
                {category.items.map((item, i) => <li key={i} className="flex items-start text-sm text-gray-700" data-id="element-182">
                    <ChevronRightIcon className="h-4 w-4 text-brand-red mr-2 mt-0.5 flex-shrink-0" data-id="element-183" />
                    {item}
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-184">
          <Link to="/services" className="inline-flex items-center bg-brand-navy text-white px-8 py-4 rounded-xl font-bold hover:bg-brand-red transition-all shadow-lg" data-id="element-185">
            View All Services
          </Link>
        </div>
      </div>
    </section>;
}